import { IAppState } from '../../redux';
import { selectIsAddJKState } from '../jk';

export const selectIsNewPublishTermsEnabled = (state: IAppState): boolean => {
  const isAddJKState = selectIsAddJKState(state);

  return !isAddJKState;
};
